import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { fmtDate, LEAD_STATUSES, STATUS_STYLES } from "@/lib/api";
import { fmtKwp, fmtMoney } from "@/lib/apolloCalc";

const waDigits = (phone) => {
  const d = phone.replace(/\D/g, "");
  return d.startsWith("39") || d.length > 10 ? d : `39${d}`;
};

export const LeadRow = ({ lead, onStatus, onOpen }) => (
  <tr data-testid={`lead-row-${lead.id}`} className="border-b border-slate-100 last:border-0 hover:bg-slate-50/60">
    <td className="whitespace-nowrap px-4 py-3 text-slate-500">{fmtDate(lead.created_at)}</td>
    <td className="px-4 py-3 font-medium text-slate-900">{lead.name}</td>
    <td className="whitespace-nowrap px-4 py-3">
      <span className="flex items-center gap-2">
        <a href={`tel:${lead.phone}`} className="hover:text-emerald-600">{lead.phone}</a>
        <a data-testid={`lead-whatsapp-${lead.id}`} href={`https://wa.me/${waDigits(lead.phone)}`} target="_blank" rel="noopener noreferrer" className="text-[#25D366]" aria-label="WhatsApp">
          <WhatsAppIcon className="h-4 w-4" />
        </a>
      </span>
    </td>
    <td className="px-4 py-3 text-slate-600">{lead.city || "—"}<span className="block text-xs text-slate-400">{lead.zone}</span></td>
    <td className="px-4 py-3 text-slate-600">{lead.building_type}</td>
    <td className="whitespace-nowrap px-4 py-3 text-slate-600">{lead.panels} pann. · {fmtKwp(lead.kwp)} kWp<span className="block text-xs text-emerald-600">{lead.feasibility}% fattibile</span>{lead.savings != null && <span data-testid={`lead-savings-${lead.id}`} className="block text-xs text-slate-500">{fmtMoney(lead.savings, lead.currency || "EUR")}/anno</span>}</td>
    <td className="px-4 py-3">
      <Select value={lead.status} onValueChange={onStatus}>
        <SelectTrigger data-testid={`lead-status-select-${lead.id}`} className={`h-8 w-44 rounded-full border text-xs font-medium ${STATUS_STYLES[lead.status]}`}><SelectValue /></SelectTrigger>
        <SelectContent>{LEAD_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
      </Select>
    </td>
    <td className="px-4 py-3 text-right">
      <button data-testid={`lead-open-${lead.id}`} onClick={onOpen} className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium hover:border-slate-900">Dettagli</button>
    </td>
  </tr>
);
